import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useShouldRenderAgencyShareChat = () => {
  const callerID = useSelector(state => state.emergencyCalls.selectedCallerID);

  const isCallReceived = useSelector(
    state =>
      state.emergencyCalls.callQueue[callerID]?.agencyShareChat?.isCallReceived,
  );

  const isCallShared = useSelector(
    state =>
      state.emergencyCalls.callQueue[callerID]?.agencyShareChat?.isCallShared,
  );

  const isAgencyShareChatEnabled = useMemo(
    () => isCallReceived || isCallShared,
    [isCallReceived, isCallShared],
  );

  return isAgencyShareChatEnabled;
};

export default useShouldRenderAgencyShareChat;
